/** @param {Date.toISOString} isoData */
const maxToDate = function (isoData) {
    isoData = `${isoData}`.split('T');
    let hora = `23:59:59.${isoData[1].split('.')[1]}`;

    return `${isoData[0]}T${hora}`;
};

/** @param {Date.toISOString} isoData */
const minToDate = function (isoData) {
    isoData = `${isoData}`.split('T');
    let hora = `00:00:00.${isoData[1].split('.')[1]}`;

    return `${isoData[0]}T${hora}`;
};

/** @param {Array} dataCadastro */
const arrayToDateString = function (dataCadastro, datetime = false) {
    const ajusta = (str) => {
        return `${str}`.padStart(2, '0');
    };

    if (Array.isArray(dataCadastro)) {
        const hora = datetime
            ? ` ${ajusta(dataCadastro[3])}:${ajusta(dataCadastro[4])}:${ajusta(dataCadastro[5])}`
            : '';
        return `${ajusta(dataCadastro[2])}/${ajusta(dataCadastro[1])}/${dataCadastro[0]}${hora}`;
    }
    return dataCadastro;
};

export function arrayToDate(date, datetime = false) {
    if (Array.isArray(date)) {
        if (!datetime) {
            return new Date(date[0], date[1] - 1, date[2]);
        } else {
            const seconds = date.length === 6 ? date[5] : null;
            return new Date(date[0], date[1] - 1, date[2], date[3], date[4], seconds);
        }
    }
    return date;
}

/**
 * @param {Date} dCompare
 * @param {Date} dInicio
 * @param {Date} dFim */
const dateBetween = function (dCompare, dInicio, dFim) {
    if (dCompare >= dInicio && dCompare <= dFim) {
        return true;
    }
    return false;
};

/**
 * @param {Date} data
 * @param {Boolean} ignoreTimezone */
const dateToISOString = (data, ignoreTimezone = true) => {
    if (ignoreTimezone) {
        return new Date(data.getTime() - data.getTimezoneOffset() * 60000).toISOString();
    }
    return data.toISOString();
};

/**
 * @param {Date} data
 * @param {Boolean} ignoreTimezone */
const dateToString = (data, ignoreTimezone = true) => {
    data = dateToISOString(data, ignoreTimezone);
    const [ano, mes, dia] = data.split('T')[0].split('-');
    return `${dia}/${mes}/${ano}`;
};

const calculaIdadePorDataNasicmento = (dataNascimentoArray) => {
    const diffMs = Date.now() - arrayToDate(dataNascimentoArray).getTime();
    const ageDt = new Date(diffMs);

    return Math.abs(ageDt.getUTCFullYear() - 1970);
};

export {
    arrayToDateString,
    calculaIdadePorDataNasicmento,
    dateBetween,
    dateToISOString,
    dateToString,
    maxToDate,
    minToDate,
};
